import { cn } from '@/lib/utils';
import React from 'react';

interface TableCell {
  col?: string;
}

interface TableRow {
  col?: TableCell[];
}

interface TableProps {
  firstRowAsTableHeadingRow?: boolean;
  boldTableContent?: boolean;
  highlightEvenRows?: boolean;    
  horizontalBorder?: boolean;
  verticalBorder?: boolean;
  textAlignment?: "left" | "center";
  caption?: string;
  row?: TableRow[];
  attributes?: React.HTMLProps<HTMLDivElement>;
}

export const Table = ({ 
  firstRowAsTableHeadingRow, 
  boldTableContent, 
  highlightEvenRows,    
  horizontalBorder, 
  verticalBorder, 
  textAlignment, 
  caption, 
  row, 
  attributes 
}: TableProps) => {
  const { key, ...rest } = attributes ?? {};
  const tableHeadingRow = firstRowAsTableHeadingRow ? row?.[0] : null;
  const tableContentRows = firstRowAsTableHeadingRow ? row?.slice(1) : row;

  const tableClass = 
    cn(
      'w-full table-auto border-collapse',
      boldTableContent && 'font-bold',
      textAlignment === 'center' && 'text-center',
      textAlignment === 'left' && 'text-left',
    );
  const tableHeadingRowClass = 
    cn(
      (horizontalBorder || verticalBorder) && '[&>th]:border-b-2',
      verticalBorder && !horizontalBorder && '[&>th]:border-r [&>th]:last:border-r-0',
      horizontalBorder && verticalBorder && '[&>th]:border [&>th]:border-b-2',
    );
  const tableContentRowClass = 
    cn(
      highlightEvenRows && 'even:bg-muted',
      horizontalBorder && !verticalBorder && '[&>td]:border-b last:[&>td]:border-b-0',
      verticalBorder && !horizontalBorder && '[&>td]:border-r [&>td]:last:border-r-0',
      horizontalBorder && verticalBorder && '[&>td]:border',
    );
  const tableCellClass = 
    cn(
      'px-4 py-3',
    );
  return (
    <div
      key={key}
      {...rest}
      className="content-table"
    >
      <table className={tableClass}>
        {tableHeadingRow && (
          <thead>
            <tr className={tableHeadingRowClass}>
              {tableHeadingRow.col?.map((cell, cellIndex) => (
                <th key={cellIndex} className={tableCellClass}>{cell.col}</th>
              ))}
            </tr>
          </thead>
        )}
        {tableContentRows && (
          <tbody>
            {tableContentRows.map((row, rowIndex) => (
              <tr key={rowIndex} className={tableContentRowClass}>
                {row.col?.map((cell, cellIndex) => (
                  <td key={cellIndex} className={tableCellClass}>{cell.col}</td>
                ))}
              </tr>
            ))}
          </tbody>
        )}
      </table>
      {caption && (
        <p className="paragraph-sm italic mt-1 text-muted-foreground">
          {caption}
        </p>
      )}
    </div>
  );
}; 